import React from "react";
import "./DownloadFormatModal.css";

const DownloadFormatModal = ({ isOpen, selectedFormat, onSelectFormat, onClose, position = {} }) => {
  if (!isOpen) return null;

  const formatOptions = [
    {
      id: "jpeg",
      name: "JPEG",
      label: "JPEG (Recommended)",
      description: "Smaller file size, transparency is not saved",
    },
    {
      id: "png",
      name: "PNG",
      label: "PNG",
      description: "Bigger file size, transparency is saved",
    },
    {
      id: "webp",
      name: "WEBP",
      label: "WEBP",
      description: "Smallest file size, transparency is saved",
    },
  ];

  const handleFormatClick = (formatId) => {
    onSelectFormat(formatId);
    onClose();
  };

  return (
    <>
      <div className="format-modal-overlay" onClick={onClose}></div>
      <div 
        className="format-modal-container"
        style={{
          top: position.top ? `${position.top}px` : 'auto',
          left: position.left ? `${position.left}px` : 'auto',
          width: position.width ? `${position.width}px` : 'auto',
        }}
      >
        <div className="format-modal-content">
          {formatOptions.map((option) => (
            <div
              key={option.id}
              className={`format-option ${
                selectedFormat === option.id ? "active" : ""
              }`}
              onClick={() => handleFormatClick(option.id)}
            >
              <div className="format-text">
                <div className="format-name">{option.label}</div>
                <div className="format-hint">{option.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default DownloadFormatModal;
